function generateId() {
    var _a;
    if (typeof window !== "undefined" && ((_a = window === null || window === void 0 ? void 0 : window.crypto) === null || _a === void 0 ? void 0 : _a.getRandomValues)) {
        return ("".concat([1e7], "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11)).replace(/[018]/g, function (c) {
            return (((c ^ window.crypto.getRandomValues(new Uint8Array(1))[0]) & 15) >> c / 4).toString(16);
        });
    }
    return 'xxxx-xxxx-xxx-xxxx'.replace(/[x]/g, function () { return (Math.floor(Math.random() * 16).toString(16)); });
}

export { generateId as g };
//# sourceMappingURL=index-69a46657.js.map
